import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { DataObject } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";

const VariableNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const varName = data?.variableName;
  const varValue = data?.variableValue;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<DataObject />}
      title="Variavel"
      color="#1976d2"
      bgColor="#F0F7FF"
      noTarget
      noSource
      isConnectable={isConnectable}
      selected={selected}
    >
      {/* Custom target handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="variable-in"
        className={getHandleClass("target", "variable-in")}
        style={{
          left: -8,
          cursor: "crosshair",
        }}
        isConnectable={isConnectable}
      />

      {/* Variable name in monospace */}
      {varName && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "3px 8px",
            borderRadius: 6,
            fontSize: 11,
            fontWeight: 600,
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
            backgroundColor: "#E3F2FD",
            color: "#1565C0",
            border: "1px solid #90CAF9",
            marginBottom: varValue ? 4 : 0,
          }}
        >
          <span style={{ color: "#1976d2", fontSize: 9, fontWeight: 400 }}>var</span>
          {varName}
        </div>
      )}

      {/* Variable value preview */}
      {varValue && (
        <div
          style={{
            fontSize: 10,
            color: "#546E7A",
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 180,
          }}
        >
          = {varValue}
        </div>
      )}

      {/* Variable type */}
      {data?.variableType && data.variableType !== "text" && (
        <div style={{ fontSize: 9, color: "#90A4AE", marginTop: 2 }}>
          Tipo: {data.variableType}
        </div>
      )}

      {/* Custom source handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="variable-out"
        className={getHandleClass("source", "variable-out")}
        style={{
          right: -8,
          cursor: "crosshair",
        }}
        isConnectable={isConnectable}
      />
    </NodeWrapper>
  );
});

VariableNode.displayName = "VariableNode";
export default VariableNode;
